var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/spacing.ts
import "@adornis/buildify/client/components/x-buildify-color-picker";
import "@adornis/buildify/client/components/x-buildify-spacing-picker";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/forms/x-checkbox.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { SPACING_KEY, SPACING_SCHEMA } from "../../schema/nodes/spacing.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { spacingAutocompletion } from "../plugins/spacingAutocompletion.js";
import "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-flex space="md">
      <x-buildify-spacing-picker
        clearable
        select
        placeholder="Abstand"
        select
        ${contentController.field(...controllerBaseKeyPath, "distance")}
      ></x-buildify-spacing-picker>
      <x-checkbox
        label="Linie anzeigen?"
        ${contentController.field(...controllerBaseKeyPath, "hasDividingLine")}
        @value-picked=${() => host.requestUpdate()}
      ></x-checkbox>
      ${content.hasDividingLine ? html`
            <x-buildify-color-picker
              placeholder="Linienfarbe"
              ${contentController.field(...controllerBaseKeyPath, "dividingLineColor")}
            ></x-buildify-color-picker>
            <x-buildify-spacing-picker
              placeholder="Liniendicke"
              ${contentController.field(...controllerBaseKeyPath, "dividingLineSize")}
            ></x-buildify-spacing-picker>
          ` : nothing}
    </x-flex>
  `;
};
var spacing = () => ({
  node: {
    name: SPACING_KEY,
    schema: SPACING_SCHEMA()
  },
  plugins: () => [spacingAutocompletion],
  menuItems: [
    {
      label: "Abstand",
      icon: "format_line_spacing",
      run: (view) => runInsertNode(SPACING_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeSpacing = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-flex
        ${css({
      background: mode === "edit" ? this.colors.accent.shade(200) : "",
      minHeight: content?.distance ?? "10px",
      minWidth: "100%"
    })}
        center
        w100
        h100
      >
        ${content?.hasDividingLine ? html`
              <x-flex
                ${css({
      background: content.dividingLineColor ?? "#333",
      height: content.dividingLineSize ?? "3px"
    })}
              ></x-flex>
            ` : nothing}
      </x-flex>
    `;
  }
};
NodeSpacing = __decorateClass([
  customElement("node-spacing")
], NodeSpacing);
export {
  NodeSpacing,
  editor,
  spacing
};
